import { render, staticRenderFns } from "./ServicosTab.vue?vue&type=template&id=1bc34a06"
import script from "./ServicosTab.vue?vue&type=script&lang=js"
export * from "./ServicosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports